// extracted by mini-css-extract-plugin
export default {"mCard":"AD-z","image":"BD-z","imageNoBackground":"CD-z","imageHasCategory":"DD-z","fullWidth":"ED-z"};